/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import { useCallback, useEffect, useState } from 'react';

import { format } from 'date-fns';
import { IoMdTrash } from 'react-icons/io';
import { MdEdit } from 'react-icons/md';
import { useHistory, useParams } from 'react-router-dom';
import { MoonLoader } from 'react-spinners';

import { ImageAvatarPlaceholder } from '~/assets/images';
import { Layout, Modal } from '~/components';
import { useAuth } from '~/hooks/auth';
import { useScreen } from '~/hooks/screen';
import { useStudent } from '~/hooks/student';
import api from '~/services/api';
import { cpfFormatter } from '~/utils/formatter';

import { Billings } from './Billings';
import { DataSheet } from './DataSheet';
import { Information } from './Information';
import { TrainingPrograms } from './TrainingPrograms';

import {
  Container,
  ContainerLoading,
  Content,
  Sidebar,
  StudentActions,
  StudentContent,
  StudentHeader,
  StudentInfo,
  DeleteModalContainer,
} from './styles';

type RouteParams = {
  userId: string;
};

const StudentProfile = () => {
  const { push } = useHistory();
  const { user } = useAuth();
  const { userId: studentId } = useParams<RouteParams>();
  const {
    location: { state },
  } = useHistory();
  const { screen, updateScreen } = useScreen();

  const { studentData, updateStudent, setStudent } = useStudent();

  const [loading, setLoading] = useState(false);
  const [componentActive, setComponentActive] = useState(() => {
    return (state as any)?.component ? (state as any).component : screen;
  });

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const loadStudent = useCallback(async () => {
    const { data } = await api.get(
      `professionals/${user?.id}/students/${studentId}`,
    );

    setStudent(data);
  }, [user, studentId, setStudent]);

  useEffect(() => {
    user && studentId && loadStudent();
  }, [studentId, user, loadStudent]);

  useEffect(() => {
    setLoading(true);

    updateStudent(studentId);

    setLoading(false);
  }, [studentId, updateStudent]);

  const sidebarList = [
    {
      value: 'token',
      title: 'Ficha cadastro',
    },
    {
      value: 'billing',
      title: 'Faturamento',
    },
    {
      value: 'dataSheet',
      title: 'Ficha técnica',
    },
    {
      value: 'trainingPrograms',
      title: 'Programas de treino',
    },
  ];

  const componentSelected: { [key: string]: JSX.Element } = {
    token: <Information />,
    billing: <Billings />,
    dataSheet: <DataSheet />,
    trainingPrograms: <TrainingPrograms />,
  };

  const handleDeleteStudent = useCallback(
    async (id: string | number) => {
      await api.delete(`students/${id}`);
      push('/professional/students');
    },
    [push],
  );

  function DeleteModal() {
    return (
      <Modal isOpen={showDeleteModal} setOpen={setShowDeleteModal}>
        <DeleteModalContainer>
          <h1>Atenção</h1>

          <p>
            Ao clicar em SIM excluirá o aluno {` `}
            <strong>{studentData.name}</strong> da base de dados!
            <br />
            Tem certeza que deseja continuar?
          </p>

          <div>
            <button
              type="button"
              onClick={() => handleDeleteStudent(studentData?.student?.id)}
            >
              Sim
            </button>
            <button type="button" onClick={() => setShowDeleteModal(false)}>
              Não
            </button>
          </div>
        </DeleteModalContainer>
      </Modal>
    );
  }

  const handleNavigateToEditStudent = useCallback(() => {
    updateScreen(componentActive);

    push(`/professional/students/${studentId}/edit`);
  }, [updateScreen, componentActive, push, studentId]);

  return (
    <Layout title="ALUNO">
      <DeleteModal />

      <Container>
        <Sidebar>
          <ul>
            {sidebarList.map((item) => (
              <li
                key={item.value}
                onClick={() => setComponentActive(item.value)}
                className={componentActive === item.value ? 'active' : ''}
              >
                <p>{item.title}</p>
              </li>
            ))}
          </ul>
        </Sidebar>

        <Content>
          {!loading ? (
            <>
              <StudentHeader>
                <StudentInfo>
                  <img
                    src={studentData?.image_url ?? ImageAvatarPlaceholder}
                    alt={`Avatar ${studentData?.name}`}
                  />

                  <div className="info">
                    <h1>{studentData?.name}</h1>
                    <p>
                      CPF:&nbsp;
                      <span>
                        {cpfFormatter(studentData?.student?.cpf ?? '')}
                      </span>
                    </p>
                    <p>
                      Data de cadastro:&nbsp;
                      <span>
                        {format(
                          new Date(studentData?.created_at ?? Date.now()),
                          'dd/MM/yyyy',
                        )}
                      </span>
                    </p>
                  </div>
                </StudentInfo>

                <StudentActions>
                  <button type="button" onClick={handleNavigateToEditStudent}>
                    <MdEdit color="#000" size={30} />
                  </button>

                  <button
                    type="button"
                    onClick={() => setShowDeleteModal(true)}
                  >
                    <IoMdTrash color="#fff" size={30} />
                  </button>
                </StudentActions>
              </StudentHeader>

              <StudentContent>
                {componentSelected[componentActive]}
              </StudentContent>
            </>
          ) : (
            <ContainerLoading>
              <MoonLoader color="#ffdf22" />
            </ContainerLoading>
          )}
        </Content>
      </Container>
    </Layout>
  );
};

export default StudentProfile;
